import React, { useState } from 'react'

import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core'

import { Settings as SettingsIcon } from 'react-feather'

import { MenuButton, PermittedByAssignmentRole } from 'components'
import {
  DeleteGovernanceProjectDialog,
  OngoingCard,
  StagesCard,
} from './components'
import helpers from 'helpers'

import { find } from 'lodash'

import theme from 'theme'

import useAuth from 'hooks/useAuth'
import usePermissions from 'hooks/usePermissions'

import constants from 'constants/index'
import useStyles from './styles'

const SummaryCard = ({
  governanceProject,
  handleProjectManagerRedirection,
  handleOpenModal,
  handleOpenFinalizedModal,
  refresh,
}) => {
  const [destroyOpen, setDestroyOpen] = useState(false)
  const {
    PENDING_STATUS_ID,
    OVERDUE_STATUS_ID,
    MANAGER_ROLE,
    PROJECT_RESPONSIBLE_ROLE,
    COMPLETED_STATUS_ID,
    ARCHIVED_STATUS_ID,
  } = constants.governanceProject

  const submitStage = find(governanceProject?.governanceProjectTemplateStages, {
    kind: 'submit_answers',
  })

  const isCompleted =
    governanceProject?.status === COMPLETED_STATUS_ID &&
    submitStage?.progressStatus === COMPLETED_STATUS_ID

  const isArchived = governanceProject?.status === ARCHIVED_STATUS_ID

  const { user } = useAuth()
  const { permitted } = usePermissions()

  const classes = useStyles()

  const assignments = helpers.governanceProject.orderAndClearAssignments(
    governanceProject?.projectAssignments,
  )

  const managePermitted = permitted(
    constants.permissions.GOVERNANCE_PROJECTS.CREATE,
  )
  const assignmentRole = managePermitted
    ? MANAGER_ROLE
    : find(assignments, { user: { id: user?.id } })?.role

  const handleConfirmDestroy = () => setDestroyOpen(true)

  return (
    <Card className={classes.card}>
      <Box className={classes.cardContainer}>
        <Box className={classes.titleContainer}>
          <Tooltip title={governanceProject?.name}>
            <Typography variant="h5" noWrap>
              {governanceProject?.name}
            </Typography>
          </Tooltip>
        </Box>
        {governanceProject?.isImported ? (
          <Chip
            label="Importado"
            variant="outlined"
            color="primary"
            size="small"
          />
        ) : (
          <PermittedByAssignmentRole
            userRole={assignmentRole}
            permittedRoles={[MANAGER_ROLE, PROJECT_RESPONSIBLE_ROLE]}
          >
            <Box
              display="flex"
              gridGap={theme.spacing(2)}
              alignItems="center"
              flexShrink={0}
            >
              {[PENDING_STATUS_ID, OVERDUE_STATUS_ID].includes(
                governanceProject?.status,
              ) && (
                <Box width="100%">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenFinalizedModal(governanceProject)}
                    fullWidth
                  >
                    Finalizar projeto
                  </Button>
                </Box>
              )}
              {isArchived && (
                <Chip
                  label="Arquivado"
                  variant="outlined"
                  color="primary"
                  size="small"
                  className={classes.archivedChip}
                />
              )}
              <Tooltip title="Configurações">
                <span>
                  <IconButton
                    color="primary"
                    onClick={() => handleOpenModal(governanceProject)}
                  >
                    <SettingsIcon size={20} />
                  </IconButton>
                </span>
              </Tooltip>

              <MenuButton>
                <Button
                  color="secondary"
                  fullWidth
                  size="small"
                  onClick={handleConfirmDestroy}
                >
                  Excluir
                </Button>
              </MenuButton>
            </Box>
          </PermittedByAssignmentRole>
        )}
      </Box>
      <Divider />
      <CardActionArea
        className={classes.cardActionArea}
        onClick={() => handleProjectManagerRedirection(governanceProject?.id)}
      >
        {isCompleted ? (
          <StagesCard
            governanceProject={governanceProject}
            handleProjectManagerRedirection={handleProjectManagerRedirection}
          />
        ) : (
          <OngoingCard
            governanceProject={governanceProject}
            assignments={assignments}
            handleOpenModal={handleOpenModal}
            assignmentRole={assignmentRole}
          />
        )}
        <Divider />
      </CardActionArea>
      <DeleteGovernanceProjectDialog
        open={destroyOpen}
        setOpen={setDestroyOpen}
        governanceProject={governanceProject}
        refresh={refresh}
      />
    </Card>
  )
}

SummaryCard.propTypes = {
  governanceProject: PropTypes.object,
  handleProjectManagerRedirection: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
}

export default SummaryCard
